import React from 'react';

import { cn } from '@lyearn/style';
import { Typography } from '@lyearn/ui';

import { FormFieldDescription } from '../types';

function Description(props: FormFieldDescription) {
  return (
    <Typography
      className={cn('mb-24 ps-8', props.className)}
      color="text-text-secondary"
      variant="body-short-01">
      {props.children}
    </Typography>
  );
}

export default Description;
